import { Button, Dropdown } from 'antd';
import { PrinterOutlined, FileTextOutlined } from '@ant-design/icons';
import { openPrintPreview, printElement } from '../../../utils/printUtils';

export const AssessmentFormHeader = () => {
    return (
        <div className="d-flex justify-content-between align-items-center my-3">
            <div style={{ flex: 1 }}></div>
            <div style={{ textAlign: 'center', flex: 2 }}>
                <h2 style={{ fontFamily: 'sans-serif' }}>
                    〘 Prakruti Ayurvedic Health Center & Hospital 〙
                </h2>
                <h4 style={{ fontFamily: 'fantasy' }}>
                    A Project By Prakruti Ayurvedic Health Resort, Satara
                </h4>
                <h3 className="mt-3">
                    In Patient Initial Medical Assessment Form (Adult)
                </h3>
            </div>
            <div style={{ flex: 1, textAlign: 'right' }} className="no-print">
                <Dropdown
                    menu={{
                        items: [
                            {
                                key: 'print',
                                label: 'Print',
                                icon: <PrinterOutlined />,
                                onClick: () => printElement('inpatient-print-area', 'In Patient Assessment Form'),
                            },
                            {
                                key: 'preview',
                                label: 'Print Preview',
                                icon: <FileTextOutlined />,
                                onClick: () => openPrintPreview('inpatient-print-area', 'In Patient Assessment Form - Preview'),
                            },
                        ],
                    }}
                    placement="bottomRight"
                >
                    <Button type="primary" icon={<PrinterOutlined />}>
                        Print Options
                    </Button>
                </Dropdown>
            </div>
        </div>
    );
};
